import React from "react";
import { useNavigate } from "react-router-dom";
import {
  createRoomFacilityDetail,
  getFacilityTypes,
} from "adminApi/RoomFaciliteDetailsApi/RoomFacilites";
import { validateForm } from "utils/validation";
import { RoomFacilityDetailRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddRoomFacilityDetailForm from "./Componates/AddRoomFacilityDetailForm";
import fields from "../json/RoomFacilityDetailFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddRoomFacilityDetail = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(
    initialValues,
    RoomFacilityDetailRules
  );

  // Fetch facility types using the standard hook — includes loading state
  const { data: facilityTypeOptions, loading: loadingTypes } = useFetchAllData(getFacilityTypes);

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await createRoomFacilityDetail({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, RoomFacilityDetailRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Room Facility Detail Created successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingTypes) && <Spinner isSpinner={true} />}
      <AddRoomFacilityDetailForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        facilityTypeOptions={facilityTypeOptions || []}
        imagePreview={values.imagePreview || values.image}
        title="Create Room Facility Detail"
        handleFileChange={handleFileChange}
      />
    </>
  );
};

export default AddRoomFacilityDetail;
